import React, { useState } from "react";
import { Navbar, Nav, Container, Image, Form } from "react-bootstrap";
import { FaGlobe, FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/AuthSlice";
import Swal from "sweetalert2";
import "./header.css";
import { setGlobalCurrency } from "utils/currency";
import { getGlobalCurrency } from "utils/currency";

export default function Header({ onToggleSidebar, sidebarOpen = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [selectedCurrency, setSelectedCurrencyState] = useState(getGlobalCurrency());

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of your account',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#001529',
      confirmButtonText: 'Yes, logout! ',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
      
      }
    });
  };
  return (
    <Navbar bg="white" expand="lg" className={`header-navbar ${sidebarOpen && window.innerWidth <= 991 ? 'sidebar-open' : ''}`}>
      <Container fluid className="header-container">

        {/* Left — menu icon */}
        <div className="header-left">
          <i className="fas fa-bars header-menu-icon" onClick={onToggleSidebar}></i>
        </div>

        {/* Right — language, admin, logout */}
        <Nav className="header-right">
<Form.Select
  size="sm"
  value={selectedCurrency}
  onChange={(e) => {
    setSelectedCurrencyState(e.target.value);
    setGlobalCurrency(e.target.value);
    window.dispatchEvent(new Event("currencyChanged"));
  }}
>
  <option value="LRD">LRD</option>
  <option value="USD">USD</option>
</Form.Select>
          {/* Language */}
          {/* <div className="header-nav-item header-language">
            <FaGlobe size={16} />
            <span className="header-text">English</span>
          </div> */}

          {/* Admin + Avatar */}
          <div className="header-nav-item header-admin">
            <div className="user-icon">
              <FaUserCircle size={20} />
            </div>
            <span className="header-text">{user?.name || 'Admin'}</span>
          </div>

          {/* Logout */}
          <div className="header-nav-item header-logout" onClick={handleLogout} style={{ cursor: 'pointer' }}>
            <RiLogoutCircleRLine size={16} />
            <span className="header-text">Logout</span>
          </div>
        </Nav>

      </Container>
    </Navbar>
  );
}